import React, { useState, useEffect } from "react";
import { Plus, Save } from "lucide-react";
import SearchBar from "../common/SearchBar";
import FormModal from "../common/FormModal";
import ActionButtons, {
  PrimaryButton,
  SecondaryButton,
} from "../common/ActionButtons";

const ClientSessions = () => {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [editingSession, setEditingSession] = useState(null);

  const [formData, setFormData] = useState({
    user_id: "",
    token_hash: "",
    expires_at: "",
    ip_address: "",
    user_agent: "",
  });

  useEffect(() => {
    fetchSessions();
  }, []);

  const fetchSessions = async () => {
    setLoading(true);
    try {
      // TODO: Implement API call
      // const data = await sessionsApi.getAll();
      // setSessions(data);
      console.log("Fetch sessions - implement API");
    } catch (error) {
      console.error("Error fetching sessions:", error);
    }
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // TODO: Implement create/update
      console.log("Save session:", formData);
      fetchSessions();
      resetForm();
    } catch (error) {
      console.error("Error saving session:", error);
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this session?")) return;
    setLoading(true);
    try {
      // TODO: Implement delete
      console.log("Delete session:", id);
      fetchSessions();
    } catch (error) {
      console.error("Error deleting session:", error);
    }
    setLoading(false);
  };

  const resetForm = () => {
    setFormData({
      user_id: "",
      token_hash: "",
      expires_at: "",
      ip_address: "",
      user_agent: "",
    });
    setEditingSession(null);
    setShowForm(false);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <SearchBar
          value={searchTerm}
          onChange={setSearchTerm}
          onRefresh={fetchSessions}
          placeholder="Search sessions..."
        />
        <PrimaryButton onClick={() => setShowForm(!showForm)} icon={Plus}>
          New Session
        </PrimaryButton>
      </div>

      <FormModal
        title={editingSession ? "Edit Session" : "New Session"}
        isOpen={showForm}
        onClose={resetForm}
      >
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="text-center py-8 text-slate-500">
            <p className="text-lg font-medium mb-2">Session Management</p>
            <p className="text-sm">
              Configure session tracking and user authentication
            </p>
            <p className="text-xs mt-4 text-slate-400">
              API integration needed
            </p>
          </div>
          <div className="flex justify-end space-x-3 pt-4">
            <SecondaryButton onClick={resetForm}>Cancel</SecondaryButton>
            <PrimaryButton type="submit" disabled={loading} icon={Save}>
              {loading ? "Saving..." : "Save Session"}
            </PrimaryButton>
          </div>
        </form>
      </FormModal>

      <div className="bg-white rounded-lg shadow-md overflow-hidden border border-slate-200">
        <table className="min-w-full divide-y divide-slate-200">
          <thead className="bg-slate-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase">
                User
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase">
                IP Address
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase">
                Expires At
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-slate-200">
            <tr>
              <td colSpan={4} className="px-6 py-12 text-center text-slate-500">
                <p className="text-lg font-medium mb-2">Client Sessions</p>
                <p className="text-sm">
                  Track active user sessions and authentication
                </p>
                <p className="text-xs mt-4 text-slate-400">
                  Connect your sessions API to display data
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ClientSessions;
